import { render, staticRenderFns } from "./DonutChart08Template.vue?vue&type=template&id=6d45c012&scoped=true"
import script from "./DonutChart08Template.vue?vue&type=script&lang=js"
export * from "./DonutChart08Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d45c012",
  null
  
)

export default component.exports